<template>
  <div class="userinfo">
    <Header titles="个人资料" class="head">
      <!-- <router-link class="rislot" slot="right" :to="{path:'/bos/perfect',query: {edit: 1}}">
        编辑
      </router-link> -->
    </Header>
    <div class="base">
      <div class="user-log">
        <router-link to="/account" class="mc-information">
          <img :src="user.avatarurl " class="head-img" alt="">
        </router-link>
        <div class="mc-name">{{user.realname}}</div>
      </div>
      <div class="bar-info">
        <template v-if="user.is_working == 1">
          <div>
            <div>工号</div>
            <div>{{user.account}}</div>
          </div>
          <div>
            <div>岗位</div>
            <div>{{user.title}}</div>
          </div>
        </template>
        <template v-else>
          <div>
            <div>学历</div>
            <div>{{user.academic}}</div>
          </div>
          <div>
            <div>标签</div>
            <div>{{user.tag}}</div>
          </div>
        </template>
      </div>
      <!-- <div class="mc-mobile">{{user.mobile}}</div> -->
    </div>
    <div class="user-list">
      <!-- <div class="user-option">
        <div class="user-msg">
          <div class="user-left">姓名</div>
          <div class="user-ri">{{user.realname || user.username }}</div>
        </div>
      </div> -->
      <!-- <div class="user-option">
        <div class="user-msg">
          <div class="user-left">手机号码</div>
          <div class="user-ri">{{user.mobile}}</div>
        </div>
      </div> -->
      <!-- <div class="user-option">
        <div class="user-msg">
          <div class="user-left">学历</div>
          <div class="user-ri">{{user.academic}}</div>
        </div>
      </div> -->
      <div class="user-option">
        <div class="user-msg">
          <div class="user-left">
            <img src="@/assets/image/user-role.png" alt="">
            角色
          </div>
          <div class="user-ri">{{user.contacts_name==='1'?'评审专家':(user.contacts_name==='2'?'咨询顾问':'专业人员')}}</div>
        </div>
      </div>
      <div class="user-option">
        <div class="user-msg">
          <div class="user-left">
            <img src="@/assets/image/user-mobile.png" alt="">手机号码
          </div>
          <div class="user-ri">{{user.mobile}}</div>
        </div>
      </div>
      <div class="user-option">
        <div class="user-msg">
          <div class="user-left">
            <img src="@/assets/image/user-email.png" alt="">邮箱
          </div>
          <div class="user-ri">{{user.email}}</div>
        </div>
      </div>
      <div class="user-foo">请核对信息，如有变更，请联系系统管理员修改</div>
    </div>
  </div>
</template>

<script>
import { getUserInfo } from '@/api/api/user'
import Header from '@/components/header'
export default {
  data() {
    return {
      user: {}
    }
  },
  components: {
    Header
  },
  created() {
    this.getUser()
  },
  methods: {
    getUser() {
      getUserInfo().then(res => {
        this.user = res.data.data
        var tarr = res.data.data.tag.split(',')
        this.$store.commit('SET_TAG', tarr)
      })
    }
  }
}
</script>

<style lang="scss">
.userinfo {
  padding: 0 12px;
  padding-top: 210px;
  min-height: 100%;
  background-color: #F6F6F4;
  background: url('~@/assets/image/back-water.png');
  background-color: #F0F0F0;
  background-size: 100% 330px;
  background-repeat: no-repeat;
  position: relative;
  .head {
    margin: 0 -12px;
  }
  .base {
    // box-shadow: 0px -1px 14px 0px rgba(103, 163, 233, 0.5);
    border-radius: 8px;
    padding: 0 15px;
    text-align: center;
    top: 44px;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    
    .bar-info {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      color: white;
      img {
        width: 16px;
        height: 18px;
      }
      div {
        padding-bottom: 4px;
      }
    }
    .user-log {
      top: -64px;
      left: 0;
      right: 0;
      margin: 0 auto;
      // border-bottom: 1px solid #ccc;
      padding-top: 10px;
    }
    .mc-mobile {
      color: #c4c0d9;
      padding-top: 10px;
    }
    .mc-name {
      padding-bottom: 19px;
      color:white;
      font-size:19px;
    }
    .head-img {
      width: 73px;
      height: 73px;
      border-radius: 7px;
    }
  }
  .rislot {
    color: white;
  }
  .user-list {
    border-radius: 16px;
    background: white;
    min-height: 50vh;
    .user-option {
      // background: white;
      height: 60px;
      padding: 0 20px;
      .user-msg {
        height: 60px;
        border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        font-size: 15px;
        .user-left {
          color: #999999;
          width: 100px;
          display: flex;
          align-items: center;
          img {
            width: 18px;
            height: 18px;
          }
        }
        .user-ri {
        }
      }
    }
    padding-top: 10px;
  }
  .user-foo {
    font-weight:400;
    margin-top: 20px;
    text-align: center;
    height: 20px;
    line-height: 20px;
    font-size: 14px;
    color: #BE0000;
  }
}
</style>